import 'css-chunksrc/client/scenes/accountCreationConfirmation/form/accountForm/selectList/styles.scss';export default {
  "selectList": "_selectList_1d5qi_1",
  "input": "_input_1d5qi_6",
  "iconBox": "_iconBox_1d5qi_21",
  "icon": "_icon_1d5qi_21",
  "opened": "_opened_1d5qi_35",
  "list": "_list_1d5qi_43",
  "item": "_item_1d5qi_57",
  "selectedItem": "_selectedItem_1d5qi_67",
  "invalidInput": "_invalidInput_1d5qi_73"
};